<template>
    <section class="container">
        <div>
            <img :src="$mq.phone ? '/static/img/survey/img_ironing_phone.jpg':'/static/img/survey/img_ironing_web.jpg'" class="img-fluid" alt="...">
        </div>
        <form data-vv-scope="survey-ironing-table" @submit.prevent="formSubmit()">
            <h4>กรุณากรอกแบบสอบถามให้ครบทุกข้อ</h4>
            <div>
                <label for="has_table"><span class="text-danger">*</span>คุณแม่บ้านมีโต๊ะรีดผ้า หรือไม่</label>
                <div class="row no-gutters pl-2">
                    <div class="exp" :class="$mq.phone ? 'col-6' : 'col-2'" >
                        <div class="checkbox">
                          <input type="radio"
                                 name="has_table"
                                 id="have"
                                 value="มี"
                                 v-validate="'required'"
                                 v-model="form.has_table"/>
                          <label class="mb-3" for="have">
                            <span> </span>
                            มี
                          </label>
                        </div>
                    </div>
                    <div class="exp" :class="$mq.phone ? 'col-6' : 'col-2'" >
                        <div class="checkbox">
                          <input type="radio"
                                 name="has_table"
                                 id="have_no"
                                 value="ไม่มี"
                                 v-validate="'required'"
                                 v-model="form.has_table"/>
                          <label class="mb-0" for="have_no">
                            <span> </span>
                            ไม่มี
                          </label>
                        </div>
                    </div>
                </div>
                <div class="mt-1 text-remark -status-alert" v-if="errors.has('survey-ironing-table.has_table')">
                    {{ $t('message.required_field') }}
                </div>
            </div>
            <div v-if="form.has_table == 'มี'">
              <label for="upload_img"><span class="text-danger">*</span>คุณแม่บ้านมีโต๊ะรีดผ้า หรือไม่</label>
                <div class="row no-gutters pl-2">
                    <div class="exp" :class="$mq.phone ? 'col-12' : 'col-4'" >
                        <div class="checkbox">
                          <input type="radio"
                                 name="upload_img"
                                 id="uploaded"
                                 value="มีรูปภาพในหน้าโปรไฟล์แล้ว"
                                 v-validate="'required'"
                                 v-model="form.upload_img"/>
                          <label class="mb-3" for="uploaded">
                            <span> </span>
                            มีรูปภาพในหน้าโปรไฟล์แล้ว
                          </label>
                        </div>
                    </div>
                    <div class="exp" :class="$mq.phone ? 'col-12' : 'col-8'" >
                        <div class="checkbox">
                          <input type="radio"
                                 name="upload_img"
                                 id="no_upload"
                                 value="ยังไม่มีรูปภาพในหน้าโปรไฟล์แล้ว"
                                 v-validate="'required'"
                                 v-model="form.upload_img"/>
                          <label class="mb-0" for="no_upload">
                            <span> </span>
                            ยังไม่มีรูปภาพในหน้าโปรไฟล์แล้ว
                          </label>
                        </div>
                    </div>
                </div>
                <div class="mt-1 text-remark -status-alert" v-if="errors.has('survey-ironing-table.upload_img')">
                    {{ $t('message.required_field') }}
                </div>
            </div>
            <div class="form-group" v-if="form.has_table == 'ไม่มี'">
                <label>สาเหตุ</label>
                <div class="select-jumbo" :style="$mq.phone ? '' : 'width:40%'">
                    <select v-model="form.causes">
                        <option value="ราคา ยังไม่สะดวกซื้อ">
                            ราคาสูง ยังไม่สะดวกซื้อ
                        </option>
                        <option value="หาซื้อไม่ได้">
                            หาซื้อไม่ได้
                        </option>
                        <option value="กำลังสั่งซื้อ">
                          กำลังสั่งซื้อ
                      </option>
                        <option value="ไม่สะดวกพกพา">
                            ไม่สะดวกพกพา
                        </option>
                        <option value="ไม่จำเป็นต่อการทำงาน">
                            ไม่จำเป็นต่อการทำงาน
                        </option>
                        <option value="อื่นๆ">
                            อื่นๆ
                        </option>
                    </select>
                </div>

                <template v-if="form.causes == 'อื่นๆ'">
                    <input  type="text"
                            class="form-control input-jumbo mt-2"
                            :style="$mq.phone ? '' : 'width:40%'"
                            id="causes_other"
                            name="causes_other"
                            placeholder="โปรดระบุ..."
                            v-model="form.causes_other"
                            >
                </template>
            </div>
            <div class="text-center pb-5">
                <button type="submit" class="btn btn__submit btn-lg px-5 mt-3" :disabled="disableState">
                    Submit
                </button>
            </div>
        </form>
    </section>
</template>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      professionalId: null,
      accessToken: null,
      disableState: true,
      form: {
        has_table: null,
        causes: null,
        causes_other: null,
        professional_id: null,
        upload_img: null
      }
    }
  },
  watch: {
    'form.has_table' (newValue, oldValue) {
      if (newValue === 'ไม่มี') {
        this.disableState = true
        this.form.upload_img = null
      } else {
        this.form.causes = null
        this.form.causes_other = null
      }
    },
    'form.upload_img' (newValue, oldValue) {
      if (newValue) {
        if (newValue === 'ยังไม่มีรูปภาพในหน้าโปรไฟล์แล้ว') {
          this.showSwalAlert('!', 'text-danger h2')
        }
        this.disableState = false
      } else {
        this.disableState = true
      }
    },
    'form.causes' (newValue, oldValue) {
      this.disableState = !newValue
    }
  },
  methods: {
    showSwalAlert (icon, classes) {
      this.$swal({
        html: `<span class="${classes}">${icon}</span> หากคุณแม่บ้านยังไม่ได้ส่งรูปโต๊ะรองรีดผ้าและอุปกรณ์รีดผ้าให้ทางแอดมิน รบกวนส่งให้แอดมินทางแชทด้วยนะคะทางแอดมินจะนำรูปเพิ่มในโปรไฟล์ เพื่ออัพเดทข้อมูลให้ค่ะ`,
        showConfirmButton: false,
        showCloseButton: true
      })
    },
    formSubmit () {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.save()
        }
      })
    },
    async save () {
      this.form.professional_id = this.professionalId
      const params = {
        professional_id: this.professionalId,
        data: this.form,
        type: 'survey_2'
      }
      const config = {
        headers: { Authorization: this.accessToken }
      }
      let swalOption = {
        type: 'error',
        title: 'ไม่สำเร็จ',
        text: 'กรุณาตรวจสอบลิงก์แบบฟอร์มหรือติดต่อเจ้าหน้าที่',
        showConfirmButton: false,
        showCloseButton: true
      }
      try {
        const { data } = await axios.post('/surveys', params, config)
        if (!data.error) {
          swalOption = {
            type: 'success',
            title: 'บันทึกสำเร็จ',
            text: 'ขอขอบคุณท่านที่ให้ความสนใจ',
            showConfirmButton: false,
            showCloseButton: true
          }
        }
      } catch (error) {
        swalOption = {
          type: 'error',
          title: error.message,
          text: 'กรุณาตรวจสอบลิงก์แบบฟอร์มหรือติดต่อเจ้าหน้าที่',
          showConfirmButton: false,
          showCloseButton: true
        }
      }
      this.$swal(swalOption)
    }
  },
  created () {
    this.professionalId = this.$route.query.professional_id
    if (this.$route.query.access_token) {
      this.accessToken = `Bearer ${this.$route.query.access_token}`
    }
  }
}
</script>
<style scoped>
.btn__submit {
    background-color: #3cc1d8;
    color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/survey/IronningTable.vue